import React from 'react'
import { useTranslation } from 'react-i18next'
import { Sparkles, Heart } from 'lucide-react'
import { Card, CardContent } from '../../../components/ui/card'
import { CARDIO_PLANS, pickPlanName, pickPlanSubtitle, pickPlanPurpose, expandPlanBlocks } from '../../../lib/myCardioPlans'

// Shown above the cardio area on every session type. Tap a tile to
// one-shot load that plan's blocks into the session draft — useful for
// quick interval plans and for stacking a Zone 2 block before lifts.
//
// Props:
// - onLoad(blocks)  — called with the expanded blocks; caller appends
//                     them to draft.cardios.
export default function CardioPresetPicker({ onLoad }) {
  const { t, i18n } = useTranslation()
  if (CARDIO_PLANS.length === 0) return null

  return (
    <Card className="border-app-primary-500/30 bg-app-primary-500/5">
      <CardContent className="p-3">
        <div className="flex items-center gap-2 mb-2">
          <Sparkles className="w-3.5 h-3.5 text-app-primary-500" />
          <p className="text-[11px] uppercase tracking-wide text-muted-foreground font-semibold" dir="auto">
            {t('workout.cardioPresets.title')}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {CARDIO_PLANS.map((plan) => {
            const purpose = pickPlanPurpose(plan, i18n.language)
            return (
              <button
                key={plan.id}
                type="button"
                onClick={() => onLoad(expandPlanBlocks(plan))}
                className="text-start rounded-lg border border-input bg-background hover:bg-accent hover:border-app-primary-500/50 transition-colors p-3"
              >
                <div className="flex items-start justify-between gap-2">
                  <p className="text-sm font-medium text-foreground" dir="auto">
                    {pickPlanName(plan, i18n.language)}
                  </p>
                  {plan.hr_max_bpm != null && (
                    <span
                      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md bg-rose-500/10 text-rose-600 dark:text-rose-400 text-[10px] font-semibold flex-shrink-0"
                      dir="ltr"
                    >
                      <Heart className="w-2.5 h-2.5" />
                      {t('workout.cardioPresets.hrBadge', { bpm: plan.hr_max_bpm })}
                    </span>
                  )}
                </div>
                <p className="text-[11px] text-muted-foreground mt-0.5" dir="auto">
                  {pickPlanSubtitle(plan, i18n.language)}
                </p>
                {purpose && (
                  <p className="text-[11px] text-muted-foreground/80 italic mt-1" dir="auto">
                    {purpose}
                  </p>
                )}
              </button>
            )
          })}
        </div>
      </CardContent>
    </Card>
  )
}
